import { ActionTree, MutationTree } from 'vuex'
import { IRootState } from '@/store'
import { IBasketState } from '@/store/modules/basket/interfaces/IBasketState'
import { IBasketAction } from '@/store/modules/basket/interfaces/IBasketAction'
import { IBasketMutation } from '@/store/modules/basket/interfaces/IBasketMutation'
import { BasketMutationTypes } from '@/store/modules/basket/interfaces/mutation-types'
import { IFetchBasketRequest } from '@/store/modules/basket/interfaces/fetchProducts/IFetchBasketRequest'
import { BasketActionTypes } from '@/store/modules/basket/interfaces/action-types'
import { apolloClient } from '@/store/graphql.config'
import { IFetchBasketResponse } from '@/store/modules/basket/interfaces/fetchProducts/IFetchBasketResponse'
import { IBasketProduct } from '@/store/modules/basket/interfaces/IBasketProduct'
import { fetchCustomerBasketQuery } from './queries/fetchCustomerBasket.query'
import { fetchProductsToCartMutation } from './mutations/fetchProductsToCart.mutation'
import { fetchProductsToCartBulk } from './mutations/fetchProductsToCartBulk.mutation'
import { IAddToBasketResponse } from './interfaces/addProductToBasket/IAddToBasketResponse'
import { IAddMultiToBasketRequest, IAddToBasketRequest } from './interfaces/addProductToBasket/IAddToBasketRequest'
import { IAddToBasketBulkRequest } from './interfaces/addProductToBasketBulk/IAddToBasketBulkRequest'
import { IRemoveFromBasketResponse } from './interfaces/removeFromBasket/IRemoveFromBasketResponse'
import { IRemoveFromBasketRequest } from './interfaces/removeFromBasket/IRemoveFromBasketRequest'
import { fetchRemoveCardItemMutation } from './mutations/fetchRemoveCardItem.mutation'
import { fetchUpdateCartItemsMutation } from './mutations/fetchUpdateCartItems.mutation'
import { fetchUpdatePricesMutation } from './mutations/fetchUpdatePrices.mutation'
import { IUpdateItemsRequest } from './interfaces/updateItems/IUpdateItemsRequest'
import { IUpdateItemsResponse } from './interfaces/updateItems/IUpdateItemsResponse'
import { IUpdatePricesRequest } from './interfaces/updatePrices/IUpdatePricesRequest'
import { Empties, IUpdatePricesResponse } from './interfaces/updatePrices/IUpdatePricesResponse'
import { fetchPlaceOrderMutation } from './mutations/fetchPlaceOrder.mutation'
import { IPlaceOrderRequest } from './interfaces/placeOrder/IPlaceOrderRequest'
import { IPlaceOrderResponse } from './interfaces/placeOrder/IPlaceOrderResponse'
import { fetchShippingAddressMutation } from './mutations/fetchShippingAddress.mutation'
import { ISetShippingAddressRequest } from './interfaces/setShippingAddress/ISetShippingAddressRequest'
import {
  ISetShippingAddressResponse,
  ShippingAddress
} from './interfaces/setShippingAddress/ISetShippingAddressResponse'
import { fetchShippingMethodMutation } from './mutations/fetchShippingMethod.mutation'
import { ISetShippingMethodRequest } from './interfaces/setShippingMethod/ISetShippingMethodRequest'
import { ISetShippingMethodResponse, ShippingMethod } from './interfaces/setShippingMethod/ISetShippingMethodResponse'
import { fetchCreateBasketMutation } from './mutations/fetchCreateBasket.mutation'
import { ISetEmptyCartResponse } from './interfaces/emptyCart/ISetEmptyCartResponse'
import { fetchCartQuery } from './queries/fetchCartQuery.query'
import { ICartQueryRequest } from './interfaces/cartQuery/ICartQueryRequest'
import {
  BaseCartQueryItem,
  BaseCartQueryResponse,
  ICartQueryResponse,
  LastCustomerSettings
} from './interfaces/cartQuery/ICartQueryResponse'
import { IError } from '@/store/modules/catalog/interfaces/common/IError'
import { fetchTransportTypeMutation } from './mutations/fetchTransportType.mutation'
import { ISetTransportTypeRequest } from './interfaces/fetchTransportType/ISetTransportTypeRequest'
import { ISetTransportTypeResponse } from './interfaces/fetchTransportType/ISetTransportTypeResponse'
import { addSaveOrderForLaterQuery } from './queries/addSaveOrderForLater.query'
import { createSuggestedCartQuery } from './queries/createSuggestedCart.query'
import { fetchSuggestedCartQuery } from './queries/fetchSuggestedCart.query'
import { IAddSaveOrderForLaterRequest, IAddSaveOrderForLaterResponse } from './interfaces/addSaveOrderForLater'
import { constants } from '@/constants'
import { fetchMinCartForCatalogQuery } from './queries/fetchMinCartForCatalogQuery.query'
import { fetchHPCartQuery } from './queries/fetchHPCartQuery.query'
import { fetchCartValuesQuery } from './queries/fetchCartValuesQuery.query'
import {
  getAvailableDateAPI,
  getDeliveryAvailableDateAPI,
  fetchOrderType,
  fetchOrderReason
} from './api/getAvailableDate'
import { IGetAvailableDateRequest, IGetDeliveryAvailableDateRequest } from './interfaces/getAvailableDates/IGetAvailableDateRequest'
import i18n from '@/i18n'
import { ICartQueryGrandTotalYourPriceDetails } from './interfaces/cartQuery/ICartQueryItemsPricesDetails'
import { fetchCustomerLastSettingsQuery } from './queries/fetchCustomerLastSettings.queries'
import { IFetchCustomerLastSettingsRequest } from './interfaces/fetchCustomerSettings/IFetchCustomerRequest'
import { IFetchCustomerLastSettingsResponse } from './interfaces/fetchCustomerSettings/IFetchCustomerResponse'
import {
  ICreateSuggestedCartRequest,
  ICreateSuggestedCartResponse,
  IFetchSuggestedCartRequest,
  IFetchSuggestedCartResponse,
  ISuggestedCartItem,
  ISuggestedCartGrouped,
  IFetchSuggestedCartGroupedResponse,
  SuggestedAggregation
} from './interfaces/suggestedCart'
import { TransportationTypes } from '@/utils/transportTypes'
import { AxiosResponse } from 'axios'
import { generalServiceV1API } from '@/store/api-instance'
import { fetchMultiProductsToCartMutation } from './mutations/fetchMultiProductsToCart.mutation'
import { fetchSuggestedCartGroupedQuery } from './queries/fetchSuggestedCartGrouped.query'
import { IFilter } from '../orders/interfaces/IFilter'
import { fetchRemoveAllCardItemSMutation } from './queries/fetchRemoveAllCardItems.query'
import { IRemoveAllBasketItemsRequest } from './interfaces/removeAllItems/IRemoveAllBasketItemsRequest'
import { IRemoveAllBasketItemsResponse } from './interfaces/removeAllItems/IRemoveAllBasketItemsResponse'

const RESPONSE_MOCKED = {
  data: {
    getSuggestedCarts: {
      items: [
        {
          summary_total_amount_wo_vat: '1074610',
          summary_total_amount_to_pay_for_goods: '1364760',
          summary_total_empty_deposit: '0',
          suggested_cart_total: '1364760',
          shipping_address: {
            payer_name: 'GASTRO HUNTERS KFT.',
            outlet_name: 'GASTRO HUNTERS KFT.',
            street: 'D\u00d3ZSA GY\u00d6RGY \u00daT 88.',
            city: 'BUDAPEST',
            country: 'Hungary',
            province: null,
            postalcode: '1068',
            sap_id: '301477',
            __typename: 'OutletShippingInformation'
          },
          products: [
            {
              sku: 'N1AU5Q8',
              image: 'https://al-uathu-magento.azurewebsites.net/media//catalog/product//a/r/arany_aszok_0_5_uveg_10_11zon.png',
              name: 'ARANY \u00c1SZOK 0,5 PAL BET',
              number_of_items_on_pallet: '40',
              number_of_items_on_layer: '8',
              total_units: 20,
              units: 0,
              number_of_layers: 0,
              number_of_pallets: 0,
              price_per_piece: '350.1',
              your_price_wo_vat: '5513.00',
              your_price_w_vat: '7002.00',
              redemption_fee: '0.00',
              multi_deposit_z099: '1008.38',
              __typename: 'FastOrderProducts'
            },
            {
              sku: 'RDJD5BX',
              image: 'https://al-uathu-magento.azurewebsites.net/media//catalog/product//d/r/dreher_craft_blonde_ale_0_5_doboz.png',
              name: 'DREHER 0,5 DOB DRS BLONDE ALE',
              number_of_items_on_pallet: '72',
              number_of_items_on_layer: '0',
              total_units: 70,
              units: 0,
              number_of_layers: 0,
              number_of_pallets: 0,
              price_per_piece: '489',
              your_price_wo_vat: '9241.00',
              your_price_w_vat: '11736.00',
              redemption_fee: '1200.00',
              multi_deposit_z099: '0.00',
              __typename: 'FastOrderProducts'
            },
            {
              sku: 'S2YD5BX',
              image: 'https://al-uathu-magento.azurewebsites.net/media//catalog/product//d/r/dreher24_citrom_0_5_can.jpg',
              name: 'DREHER 24 0,5 DOB CITROM',
              number_of_items_on_pallet: '72',
              number_of_items_on_layer: '9',
              total_units: 40,
              units: 0,
              number_of_layers: 0,
              number_of_pallets: 0,
              price_per_piece: '420',
              your_price_wo_vat: '7937.00',
              your_price_w_vat: '10080.00',
              redemption_fee: '0.00',
              multi_deposit_z099: '0.00',
              __typename: 'FastOrderProducts'
            }
          ],
          __typename: 'FastOrder'
        }
      ],
      __typename: 'FastOrderData'
    }
  }
}

const state = (): IBasketState => ({
  id: '',
  emptyCartId: '',
  suggestedBaskets: [],
  suggestedCarts: [],
  suggestedCartsGrouped: {} as ISuggestedCartGrouped,
  items: [],
  basketLoading: false,
  error: null,
  query: {} as BaseCartQueryResponse,
  shippingAddress: [],
  shippingMethods: [],
  availablePaymentMethods: null,
  paymentMethod: '',
  paymentMethodCode: '',
  prices: {} as IUpdatePricesResponse,
  order: {} as IPlaceOrderResponse,
  availableDate: '',
  availableFeeDate: '',
  availableDays: [],
  filteredDeliveryDates: [],
  deliveryDate: '',
  shipmentId: '',
  transportType: '',
  progressBarMsg: '',
  customerSettings: {} as LastCustomerSettings,
  suggestedCart: {},
  empties: [],
  updatedEmpties: [],
  defaultEmpties: [],
  separatedOrder: [],
  showToastDetails: { show: false, productName: '', actionType: '' },
  orderReason: {} as any,
  orderType: {} as any,
  shippingType: '',
  hasCalendarException: false,
  suggestedCartsFilters: [],
  suggestedCartHasPackages: false,
  isGroupedViewEnabled: false
})

const getters = {
  progressBarMessage: (state: IBasketState) => {
    const progressBar = state.query?.progress_bar_data
    const customerRoleType = constants.customertype

    if (progressBar) {
      const customerType = localStorage.getItem('customertype')
      if (customerType === customerRoleType.POS_HORECA) {
        if (progressBar?.iKegFlag === 'yes') {
          if (progressBar?.iTotalQty > progressBar?.iMaximumUnit) {
            return i18n.global.t('The number of units has been exceeded.')
          }
        } else {
          if (progressBar?.iTotalQty < progressBar?.iMinimumUnit) {
            return i18n.global.t('The minimum number of units has not been reached, please add more goods.')
          } else if (progressBar?.iTotalQty > progressBar?.iMaximumUnit) {
            return i18n.global.t('The number of units has been exceeded.')
          }
        }
      } else if (customerType === customerRoleType.POS_FOOD) {
        if (progressBar?.iTotalQty > progressBar?.iMaximumUnit) {
          return i18n.global.t('The number of units has been exceeded.')
        }
        if (progressBar?.iTotalQty < progressBar?.iMinimumUnit) {
          return i18n.global.t('The minimum number of units has not been reached, please add more goods.')
        }
      } else if (customerType === customerRoleType.WHS) {
        if (progressBar?.iTotalCartPalletQty < progressBar?.iMinimumOrderPallet) {
          return i18n.global.t('The minimum number of pallets has not yet been reached, please add more goods.')
        }
        if (progressBar?.iTotalCartWeight > progressBar?.iMaximumOrderWeight) {
          return i18n.global.t('The weight of the order exceeds the limit, reduce the quantity to proceed with the order.')
        }
      }
      return i18n.global.t('The required quantity of goods has been reached.')
    }
    return ''
  },
  progressBarMessageClass: (state: IBasketState) => {
    const progressBar = state.query?.progress_bar_data
    const customerRoleType = constants.customertype

    if (progressBar) {
      const customerType = localStorage.getItem('customertype')
      if (customerType === customerRoleType.POS_HORECA) {
        if (progressBar?.iKegFlag === 'yes') {
          if (progressBar?.iTotalQty > progressBar?.iMaximumUnit) {
            return 'secondary-red'
          }
        } else {
          if (progressBar?.iTotalQty < progressBar?.iMinimumUnit) {
            return 'secondary-red'
          } else if (progressBar?.iTotalQty > progressBar?.iMaximumUnit) {
            return 'secondary-red'
          }
        }
      } else if (customerType === customerRoleType.POS_FOOD) {
        if (progressBar?.iTotalQty > progressBar?.iMaximumUnit) {
          return 'secondary-red'
        }
        if (progressBar?.iTotalQty < progressBar?.iMinimumUnit) {
          return 'secondary-red'
        }
      } else if (customerType === customerRoleType.WHS) {
        if (progressBar?.iTotalCartPalletQty < progressBar?.iMinimumOrderPallet) {
          return 'secondary-red'
        }
        if (progressBar?.iTotalCartWeight > progressBar?.iMaximumOrderWeight) {
          return 'secondary-red'
        }
      }
      return 'primary-green'
    }
    return ''
  },
  progressBarSuccess (state: IBasketState, getters: any) {
    return getters.progressBarMessage === i18n.global.t('The minimum order capacity has been reached.')
  },
  showProgressBarMessage (state: IBasketState) {
    return state.query?.delivery_method !== TransportationTypes.EMPTY_SMALL
  }
}

const mutations: MutationTree<IBasketState> & IBasketMutation = {
  [BasketMutationTypes.SET_EMPTY_CART] (state, payload: string): void {
    state.emptyCartId = payload
  },
  [BasketMutationTypes.SET_CART_QUERY] (state, payload: BaseCartQueryResponse): void {
    state.query = payload
  },
  [BasketMutationTypes.SET_BASKET_ID] (state, payload: string): void {
    state.id = payload
  },
  [BasketMutationTypes.ADD_SUGGESTED_BASKET] (state, payload: BaseCartQueryResponse): void {
    const idx = state.suggestedBaskets.findIndex((b) => b.ship_to_id === payload.ship_to_id)
    if (idx > -1) {
      state.suggestedBaskets[idx] = payload
    } else {
      state.suggestedBaskets.push(payload)
    }
  },
  [BasketMutationTypes.SET_SUGGESTED_BASKET] (state, payload: IFetchSuggestedCartResponse): void {
    state.suggestedCarts = payload.getSuggestedCarts?.items
  },
  [BasketMutationTypes.SET_SUGGESTED_BASKET_HAS_PACKAGES] (state, payload: IFetchSuggestedCartResponse): void {
    state.suggestedCartHasPackages = payload.getSuggestedCarts?.has_packages
  },
  [BasketMutationTypes.SET_SUGGESTED_BASKET_GROUPED] (state, payload: IFetchSuggestedCartGroupedResponse): void {
    state.suggestedCartsGrouped = payload.getSuggestedCarts
  },
  [BasketMutationTypes.SET_SUGGESTED_FILTERS] (state, payload:IFetchSuggestedCartResponse): void {
    state.suggestedCartsFilters = payload.getSuggestedCarts.aggregations || []
  },
  [BasketMutationTypes.RESET_SUGGESTED_BASKETS] (state): void {
    state.suggestedBaskets = []
  },
  [BasketMutationTypes.SET_FIRST_AVAILABLE_DATE] (state, payload: any) {
    state.availableDate = payload
  },
  [BasketMutationTypes.SET_FIRST_FEE_AVAILABLE_DATE] (state, payload: any) {
    state.availableFeeDate = payload
  },
  [BasketMutationTypes.SET_CALENDAR_EXCEPTION] (state, payload: any) {
    state.hasCalendarException = payload
  },
  [BasketMutationTypes.SET_BASKET_ITEMS] (state, payload: IBasketProduct[]): void {
    state.items = payload
  },
  [BasketMutationTypes.SET_ERROR] (state, payload: unknown): void {
    state.error = payload
  },
  [BasketMutationTypes.PAYMENT_METHOD_CODE] (state, payload: string): void {
    state.paymentMethodCode = payload
  },
  [BasketMutationTypes.SET_LOADING] (state, payload: boolean): void {
    state.basketLoading = payload
  },
  [BasketMutationTypes.SET_GROUPED_VIEW_SUGGESTED] (state, payload: boolean): void {
    state.isGroupedViewEnabled = payload
  },
  [BasketMutationTypes.SET_SHIPPING_ADDRESS] (state, payload: ShippingAddress[]): void {
    state.shippingAddress = payload
  },
  [BasketMutationTypes.SET_SHIPPING_METHODS] (state, payload: ShippingMethod[]): void {
    state.shippingMethods = payload
  },
  [BasketMutationTypes.SET_PRICES] (state, payload: IUpdatePricesResponse): void {
    state.prices = payload
  },
  [BasketMutationTypes.SET_ORDER] (state, payload: IPlaceOrderResponse): void {
    state.order = payload
  },
  [BasketMutationTypes.SET_DELIVERY_DATE] (state, payload: string): void {
    state.deliveryDate = payload
  },
  [BasketMutationTypes.SET_SHIPMENT_ID] (state, payload: string): void {
    state.shipmentId = payload
  },
  [BasketMutationTypes.PAYMENT_METHOD] (state, payload: string): void {
    state.paymentMethod = payload
  },
  [BasketMutationTypes.SET_TRANSPORT_TYPE] (state, payload: string): void {
    state.transportType = payload
  },
  [BasketMutationTypes.SET_PROGRESS_BAR] (state, payload: string): void {
    state.progressBarMsg = payload
  },
  [BasketMutationTypes.SET_CUSTOMER_SETTINGS] (state, payload: LastCustomerSettings): void {
    state.customerSettings = payload
  },
  [BasketMutationTypes.SET_EMPTIES] (state, payload: Empties[]): void {
    state.empties = payload
  },
  [BasketMutationTypes.SET_DEFAULT_EMPTIES] (state, payload: Empties[]): void {
    state.defaultEmpties = payload
  },
  [BasketMutationTypes.SET_UPDATED_EMPTIES] (state, payload: Empties[]): void {
    state.updatedEmpties = payload
  },
  [BasketMutationTypes.SET_SEPARATED_ORDER] (state, payload: Empties[]): void {
    state.separatedOrder = payload
  },

  [BasketMutationTypes.SET_TOAST_NOTIFICATION_DETAILS] (state, payload: any): void {
    state.showToastDetails = payload
  },
  [BasketMutationTypes.SET_AVAILABLE_DAYS] (state, payload: string[]) {
    state.availableDays = payload
  },
  [BasketMutationTypes.SET_FILTERED_AVAILABLE_DAYS] (state, payload: string[]) {
    state.filteredDeliveryDates = payload
  },
  [BasketMutationTypes.ORDER_REASON] (state, payload: any): void {
    state.orderReason = payload
  },
  [BasketMutationTypes.ORDER_TYPE] (state, payload: any): void {
    state.orderType = payload
  },
  [BasketMutationTypes.SET_SHIPPING_TYPE] (state, payload: string): void {
    state.shippingType = payload
  }
}

const actions: ActionTree<IBasketState, IRootState> & IBasketAction = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async [BasketActionTypes.RESET_SUGGESTED_BASKETS] ({ commit }) {
    await commit(BasketMutationTypes.RESET_SUGGESTED_BASKETS)
  },

  async [BasketActionTypes.CREATE_EMPTY_CART] ({ commit }) {
    await apolloClient.mutate<ISetEmptyCartResponse, object>({
      mutation: fetchCreateBasketMutation
    })
  },
  async [BasketActionTypes.FETCH_CUSTOMER_LAST_SETTINGS] ({ commit }, dto: IFetchCustomerLastSettingsRequest) {
    const { data } = await apolloClient.mutate<IFetchCustomerLastSettingsResponse, IFetchCustomerLastSettingsRequest>({
      mutation: fetchCustomerLastSettingsQuery,
      variables: {
        cart_id: dto.cart_id
      }
    })
    if (data) {
      commit(BasketMutationTypes.SET_CUSTOMER_SETTINGS, data?.cart)
    }
  },
  async [BasketActionTypes.GET_FIRST_AVAILABLE_DATE] ({ commit }, dto: IGetAvailableDateRequest) {
    if (dto.soldToId !== '') {
      const response = await getAvailableDateAPI(dto)
      const feeDate = response.firstAvailableDateWithFee
      if (feeDate) {
        commit(BasketMutationTypes.SET_FIRST_FEE_AVAILABLE_DATE, feeDate)
      }
      commit(BasketMutationTypes.SET_CALENDAR_EXCEPTION, response?.hasCalendarException)
      commit(BasketMutationTypes.SET_FIRST_AVAILABLE_DATE, response.firstAvailableDate)
    }
  },
  async [BasketActionTypes.GET_DELIVERY_AVAILABLE_DATE] ({ commit }, dto: IGetDeliveryAvailableDateRequest) {
    await getDeliveryAvailableDateAPI(dto).then((res) => {
      commit(BasketMutationTypes.SET_AVAILABLE_DAYS, res?.allDeliveryDate)
      commit(BasketMutationTypes.SET_FILTERED_AVAILABLE_DAYS, res?.filteredDeliveryDate)
    })
  },
  async [BasketActionTypes.FETCH_CART_QUERY] ({ commit }, dto: ICartQueryRequest) {
    commit(BasketMutationTypes.SET_LOADING, true)
    try {
      const { data } = await apolloClient.mutate<ICartQueryResponse, ICartQueryRequest>({
        mutation: fetchCartQuery,
        variables: {
          cart_id: dto.cart_id
        }
      })

      if (data) {
        const normalizedCartData = mappingPriceValues(data)
        if (normalizedCartData?.cart?.delivery_date) {
          localStorage.setItem('deliveryDate', normalizedCartData?.cart?.delivery_date)
        }
        commit(BasketMutationTypes.SET_CART_QUERY, normalizedCartData?.cart)
        commit(BasketMutationTypes.SET_DELIVERY_DATE, normalizedCartData?.cart?.delivery_date || '')
        commit(BasketMutationTypes.SET_BASKET_ITEMS, normalizedCartData?.cart?.items)
      }
      commit(BasketMutationTypes.SET_LOADING, false)
    } catch (error) {
      commit(BasketMutationTypes.SET_LOADING, false)
      commit(BasketMutationTypes.SET_ERROR, error as IError[])
      console.error('fetch basket error', error)
    }
  },
  async [BasketActionTypes.FETCH_MIN_CART_QUERY_FOR_CATALOG] ({ commit }, dto: ICartQueryRequest) {
    const { data } = await apolloClient.mutate<ICartQueryResponse, ICartQueryRequest>({
      mutation: fetchMinCartForCatalogQuery,
      variables: {
        cart_id: dto.cart_id
      }
    })
    if (data) {
      data.cart = parseCartQuery(data.cart)
    }
    if (data?.cart?.delivery_date) {
      localStorage.setItem('deliveryDate', data?.cart?.delivery_date)
    }
    commit(BasketMutationTypes.SET_CART_QUERY, data?.cart)
    commit(BasketMutationTypes.SET_DELIVERY_DATE, data?.cart?.delivery_date || '')
    commit(BasketMutationTypes.SET_BASKET_ITEMS, data?.cart?.items)
  },

  // fetch cart query on Homepage
  async [BasketActionTypes.FETCH_HP_CART_QUERY] ({ commit }, dto: ICartQueryRequest) {
    const { data } = await apolloClient.mutate<ICartQueryResponse, ICartQueryRequest>({
      mutation: fetchHPCartQuery,
      variables: {
        cart_id: dto.cart_id
      }
    })
    if (data) {
      data.cart.grand_total_your_price_details = JSON.parse(data?.cart.grand_total_your_price_details as string)
      commit(BasketMutationTypes.SET_CART_QUERY, data?.cart)
      commit(BasketMutationTypes.SET_DELIVERY_DATE, data?.cart?.delivery_date || '')
      commit(BasketMutationTypes.SET_BASKET_ITEMS, data?.cart?.items)
    }
  },

  async [BasketActionTypes.FETCH_CART_VALUES] ({ commit }, dto: ICartQueryRequest) {
    const { data } = await apolloClient.mutate<ICartQueryResponse, ICartQueryRequest>({
      mutation: fetchCartValuesQuery,
      variables: {
        cart_id: dto.cart_id
      }
    })
    commit(BasketMutationTypes.SET_CART_QUERY, {
      delivery_date: data?.cart.delivery_date,
      delivery_method: data?.cart?.delivery_method,
      ship_to_id: data?.cart?.ship_to_id,
      grand_total_your_price_details: JSON.parse(data?.cart?.grand_total_your_price_details as string),
      progress_bar_data: data?.cart?.progress_bar_data,
      outlet_details: data?.cart.outlet_details
    })
  },
  async [BasketActionTypes.FETCH_BASKET_ID] ({ commit }) {
    commit(BasketMutationTypes.SET_LOADING, true)
    const { data } = await apolloClient.query<IFetchBasketResponse, IFetchBasketRequest>({
      query: fetchCustomerBasketQuery
    })
    try {
      if (data) {
        commit(BasketMutationTypes.SET_BASKET_ID, data?.customerCart.id)
        commit(BasketMutationTypes.SET_LOADING, false)
      }
    } catch (error) {
      commit(BasketMutationTypes.SET_LOADING, false)
      commit(BasketMutationTypes.SET_ERROR, error as IError[])
      console.error('fetch basket error', error)
    }
  },
  async [BasketActionTypes.FETCH_ADD_TO_BASKET_BULK] ({ commit }, dto: IAddToBasketBulkRequest) {
    try {
      localStorage.setItem('isFirstAddToCart', 'false')

      if (!dto?.bypassloading) {
        commit(BasketMutationTypes.SET_LOADING, true)
      }
      await apolloClient.mutate<IAddToBasketResponse, IAddToBasketBulkRequest>({
        mutation: fetchProductsToCartBulk,
        variables: {
          cart_id: dto.cart_id,
          cartItems: dto.cartItems
        }
      })
      commit(BasketMutationTypes.SET_LOADING, false)
    } catch (error: any) {
      console.error('add to cart error:', error)
      commit(BasketMutationTypes.SET_LOADING, false)
      throw new Error(error.message)
    }
  },
  async [BasketActionTypes.FETCH_ADD_TO_BASKET] ({ commit }, dto: IAddToBasketRequest) {
    try {
      localStorage.setItem('isFirstAddToCart', 'false')

      if (!dto?.bypassloading) {
        commit(BasketMutationTypes.SET_LOADING, true)
      }
      await apolloClient.mutate<IAddToBasketResponse, IAddToBasketRequest>({
        mutation: fetchProductsToCartMutation,
        variables: {
          cart_id: dto.cart_id,
          sku: dto.sku,
          quantity: dto.quantity,
          number_of_layer: dto.number_of_layer,
          number_of_pallet: dto.number_of_pallet,
          entered_options: dto.entered_options,
          selected_options: dto.selected_options
        }
      })
      commit(BasketMutationTypes.SET_LOADING, false)
      if (dto.productName !== '') {
        commit(BasketMutationTypes.SET_TOAST_NOTIFICATION_DETAILS, {
          show: true,
          productName: dto.productName,
          actionType: 'add'
        })
      }
    } catch (error: any) {
      console.error('add to cart error:', error)
      commit(BasketMutationTypes.SET_LOADING, false)
      throw new Error(error.message)
    }
  },
  async [BasketActionTypes.REMOVE_ITEM] ({ commit }, dto: IRemoveFromBasketRequest) {
    commit(BasketMutationTypes.SET_LOADING, true)
    const { data } = await apolloClient.mutate<IRemoveFromBasketResponse, IRemoveFromBasketRequest>({
      mutation: fetchRemoveCardItemMutation,
      variables: {
        cart_id: dto.cart_id,
        cart_item_id: dto.cart_item_id
      }
    })
    if (data?.removeItemFromCart?.cart?.items) {
      commit(BasketMutationTypes.SET_CART_QUERY, { items: data?.removeItemFromCart?.cart?.items })
    }
    commit(BasketMutationTypes.SET_LOADING, false)
  },
  async [BasketActionTypes.REMOVE_ALL_ITEMS] ({ commit }, dto: IRemoveAllBasketItemsRequest) {
    try {
      commit(BasketMutationTypes.SET_LOADING, true)
      const { data } = await apolloClient.mutate<IRemoveAllBasketItemsResponse, IRemoveAllBasketItemsRequest>({
        mutation: fetchRemoveAllCardItemSMutation,
        variables: {
          cart_id: dto.cart_id
        }
      })
      if (data?.removeAllItems?.message) {
        commit(BasketMutationTypes.SET_CART_QUERY, { items: [] })
        commit(BasketMutationTypes.SET_BASKET_ITEMS, [])
      }
      commit(BasketMutationTypes.SET_LOADING, false)
    } catch (error: any) {
      console.error(error)
      commit(BasketMutationTypes.SET_LOADING, false)
      throw new Error(error.message)
    }
  },
  async [BasketActionTypes.UPDATE_ITEMS] ({ commit, state }, dto: IUpdateItemsRequest) {
    try {
      if (!dto?.bypassloading) {
        commit(BasketMutationTypes.SET_LOADING, true)
      }

      const { data } = await apolloClient.mutate<IUpdateItemsResponse, IUpdateItemsRequest>({
        mutation: fetchUpdateCartItemsMutation,
        variables: {
          cart_id: dto.cart_id,
          cart_items: dto.cart_items
        }
      })
      if (dto.productName !== '') {
        commit(BasketMutationTypes.SET_TOAST_NOTIFICATION_DETAILS, {
          show: true,
          productName: dto.productName,
          actionType: 'update'
        })
      }
      if (data) {
        const updated = [] as any
        data.updateCartItems.cart = parseCartQuery(data?.updateCartItems.cart)
        for (let i = 0; i < state.items?.length; i += 1) {
          for (let j = 0; j < data?.updateCartItems?.cart?.items?.length; j += 1) {
            if (state.items[i].id === data.updateCartItems.cart.items[j].id) {
              updated.push({
                id: state.items[i].id,
                product: state.items[i].product,
                number_of_layer: data.updateCartItems.cart.items[j].number_of_layer,
                number_of_layer_total: data.updateCartItems.cart.items[j].number_of_layer_total,
                number_of_packages: data.updateCartItems.cart.items[j].number_of_packages,
                number_of_pallet: data.updateCartItems.cart.items[j].number_of_pallet,
                quantity: data.updateCartItems.cart.items[j].quantity,
                quantity_total: data.updateCartItems.cart.items[j].quantity_total,
                prices: {
                  ...data.updateCartItems.cart.items[j].prices,
                  favourites: state.items[i].prices.favourites
                }
              })
            }
          }
        }
        commit(BasketMutationTypes.SET_BASKET_ITEMS, updated)
        commit(BasketMutationTypes.SET_LOADING, false)
      }
    } catch (error) {
      commit(BasketMutationTypes.SET_LOADING, false)
      commit(BasketMutationTypes.SET_ERROR, error as IError[])
      console.error('update items error:', error)
    }
  },
  async [BasketActionTypes.UPDATE_PRICES] ({ commit, rootGetters }, dto: IUpdatePricesRequest) {
    try {
      commit(BasketMutationTypes.SET_LOADING, true)
      const queryVariables = (dto.simulate_type === 'packages')
        ? {
            cart_id: dto.cart_id,
            delivery_date: dto.delivery_date,
            date_popup: dto.date_popup,
            payment_method: dto.payment_method,
            outlet_order_type: dto.outlet_order_type,
            delivery_method: dto.delivery_method,
            payment_method_title: dto.payment_method_title,
            note_for_driver: dto.note_for_driver,
            shipping_type: dto.shipping_type,
            order_reason: dto.order_reason,
            simulate_type: dto.simulate_type,
            ship_to_id: dto.ship_to_id,
            sold_to_id: dto.sold_to_id,
            package_products: dto.package_products
          }
        : {
            cart_id: dto.cart_id,
            delivery_date: dto.delivery_date,
            date_popup: dto.date_popup,
            payment_method: dto.payment_method,
            outlet_order_type: dto.outlet_order_type,
            delivery_method: dto.delivery_method,
            payment_method_title: dto.payment_method_title,
            note_for_driver: dto.note_for_driver,
            shipping_type: dto.shipping_type,
            order_reason: dto.order_reason,
            confirmation_email: dto.confirmation_email
          }
      const { data } = await apolloClient.mutate<IUpdatePricesResponse, IUpdatePricesRequest>({
        mutation: fetchUpdatePricesMutation,
        variables: queryVariables as unknown as IUpdatePricesRequest
      })
      if (data?.updatePrices) {
        commit(BasketMutationTypes.SET_PRICES, data?.updatePrices)
        commit(BasketMutationTypes.SET_LOADING, false)
        return data
      }
    } catch (error) {
      commit(BasketMutationTypes.SET_LOADING, false)
      commit(BasketMutationTypes.SET_ERROR, error as IError[])
      console.error('update prices error:', error)
    }
  },
  async [BasketActionTypes.FETCH_SHIPPING_ADDRESS] ({ commit }, dto: ISetShippingAddressRequest) {
    try {
      const { data } = await apolloClient.mutate<ISetShippingAddressResponse, ISetShippingAddressRequest>({
        mutation: fetchShippingAddressMutation,
        variables: {
          cart_id: dto.cart_id,
          shipping_addresses: dto.shipping_addresses
        }
      })
      commit(BasketMutationTypes.SET_SHIPPING_ADDRESS, data?.setShippingAddressesOnCart)
    } catch (error) {
      console.error('shipping address error', error)
    }
  },
  async [BasketActionTypes.FETCH_SHIPPING_METHODS] ({ commit }, dto: ISetShippingMethodRequest) {
    try {
      const { data } = await apolloClient.mutate<ISetShippingMethodResponse, ISetShippingMethodRequest>({
        mutation: fetchShippingMethodMutation,
        variables: {
          cart_id: dto.cart_id,
          shipping_methods: dto.shipping_methods
        }
      })
      const method = data?.setShippingMethodsOnCart?.cart.shipping_addresses as any
      if (typeof method !== 'undefined') {
        commit(BasketMutationTypes.SET_SHIPPING_METHODS, method[0]?.selected_shipping_method)
      }
    } catch (error) {
      console.error('shipping methods error', error)
    }
  },
  async [BasketActionTypes.FETCH_TRANSPORT_TYPE] ({ commit }, dto: ISetTransportTypeRequest) {
    try {
      const { data } = await apolloClient.mutate<ISetTransportTypeResponse, ISetTransportTypeRequest>({
        mutation: fetchTransportTypeMutation,
        variables: {
          transporttype: dto.transporttype,
          cart_id: dto.cart_id,
          outletid: Number((localStorage.getItem('shipToId') as string) || 0),
          datepopup: localStorage.getItem('deliveryDate') as string,
          store: localStorage.getItem('store') as string
        }
      })
      if (data?.setTransportType?.message) {
        commit(BasketMutationTypes.SET_TRANSPORT_TYPE, dto.transporttype)
        localStorage.setItem('shippingMethod', dto.transporttype)
        const defaultNonEmptyTransportType = ['flatrate_flatrate', 'selfpickup_selfpickup']
        defaultNonEmptyTransportType.push('freeshipping_freeshipping')

        if (defaultNonEmptyTransportType.includes(dto.transporttype)) {
          localStorage.setItem('onlyEmpties', JSON.stringify(0))
        } else {
          localStorage.setItem('onlyEmpties', JSON.stringify(1))
        }
      }
    } catch (error) {
      commit(BasketMutationTypes.SET_ERROR, error as IError[])
      console.error('transport type error', error)
    }
  },
  async [BasketActionTypes.PLACE_ORDER] ({ commit }, dto: IPlaceOrderRequest) {
    commit(BasketMutationTypes.SET_LOADING, true)
    try {
      const { data } = await apolloClient.mutate<IPlaceOrderResponse, IPlaceOrderRequest>({
        mutation: fetchPlaceOrderMutation,
        variables: {
          cart_id: dto.cart_id,
          empty_return_flag: dto.empty_return_flag?.toString()
        }
      })
      if (data) {
        commit(BasketMutationTypes.SET_ORDER, data?.placeOrder?.order)
        commit(BasketMutationTypes.SET_BASKET_ITEMS, [])
        localStorage.removeItem('customerOrderNumber')
        localStorage.removeItem('noteForDriver')
      }
      commit(BasketMutationTypes.SET_ERROR, [])
    } catch (error: any) {
      commit(BasketMutationTypes.SET_ERROR, [error?.message])
      commit(BasketMutationTypes.SET_LOADING, false)
      console.error('place order error', error)
    }
  },
  async [BasketActionTypes.SAVE_ORDER_FOR_LATER] (
    { commit },
    { cartId, noteForDriver, customerOrderNumber }: IAddSaveOrderForLaterRequest
  ) {
    try {
      const { data } = await apolloClient.query<IAddSaveOrderForLaterResponse, IAddSaveOrderForLaterRequest>({
        query: addSaveOrderForLaterQuery,
        variables: {
          cartId,
          noteForDriver,
          customerOrderNumber
        }
      })
      commit(BasketMutationTypes.SET_BASKET_ITEMS, [])
      return data
    } catch (error) {
      console.error(error)
    }
  },
  async [BasketActionTypes.CREATE_SUGGESTED_CART] ({ commit }, dto: ICreateSuggestedCartRequest) {
    try {
      commit(BasketMutationTypes.SET_LOADING, true)
      const { data } = await apolloClient.query<ICreateSuggestedCartResponse, ICreateSuggestedCartRequest>({
        query: createSuggestedCartQuery,
        variables: {
          shipTo: dto.shipTo,
          cartId: dto?.cartId
        }
      })

      if (data && data?.suggestedCart?.cartId) {
        const id: string = data.suggestedCart.cartId
        if (id) {
          const { data } = await apolloClient.mutate<ICartQueryResponse, ICartQueryRequest>({
            mutation: fetchCartQuery,
            variables: {
              cart_id: id
            }
          })

          if (data) {
            data.cart = parseCartQuery(data.cart)
            const normalizedCartData = mappingPriceValues(data)
            commit(BasketMutationTypes.ADD_SUGGESTED_BASKET, normalizedCartData.cart)
          }
        }
      }
      commit(BasketMutationTypes.SET_LOADING, false)
    } catch (error) {
      console.error(error)
      commit(BasketMutationTypes.SET_ERROR, [error as IError])
      commit(BasketMutationTypes.SET_LOADING, false)
    }
  },
  async [BasketActionTypes.FETCH_SUGGESTED_CART] ({ commit }, dto: IFetchSuggestedCartRequest & IFilter) {
    const variables = dto
    if (!variables?.sort) {
      variables.sort = { name: 'ASC' }
    }
    try {
      commit(BasketMutationTypes.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchSuggestedCartResponse, IFetchSuggestedCartRequest & IFilter>({
        query: fetchSuggestedCartQuery,
        variables: {
          ...variables
        }
      })

      if (data) {
        commit(BasketMutationTypes.SET_SUGGESTED_BASKET, data)
        commit(BasketMutationTypes.SET_SUGGESTED_FILTERS, data)
        commit(BasketMutationTypes.SET_SUGGESTED_BASKET_HAS_PACKAGES, data)
      }
      commit(BasketMutationTypes.SET_LOADING, false)
    } catch (error) {
      console.error(error)
      commit(BasketMutationTypes.SET_ERROR, [error as IError])
      commit(BasketMutationTypes.SET_LOADING, false)
    }
  },

  async [BasketActionTypes.FETCH_SUGGESTED_CART_GROUPED] ({ commit }, dto: IFetchSuggestedCartRequest) {
    const sort = {} as any
    if (dto?.sort?.name && dto?.sort?.order) {
      sort[dto.sort.name] = dto.sort.order
    }
    try {
      commit(BasketMutationTypes.SET_LOADING, true)
      const { data } = await apolloClient.query<IFetchSuggestedCartResponse, IFetchSuggestedCartRequest>({
        query: fetchSuggestedCartGroupedQuery,
        variables: {
          ship_tos: dto.ship_tos,
          search: dto.search ?? '',
          sort
        }
      })

      if (data) {
        commit(BasketMutationTypes.SET_SUGGESTED_BASKET_GROUPED, data)
        commit(BasketMutationTypes.SET_SUGGESTED_BASKET_HAS_PACKAGES, data)
      }
      commit(BasketMutationTypes.SET_LOADING, false)
    } catch (error) {
      console.error(error)
      commit(BasketMutationTypes.SET_ERROR, [error as IError])
      commit(BasketMutationTypes.SET_LOADING, false)
    }
  },
  async [BasketActionTypes.FETCH_ADD_MULTI_TO_BASKET] ({ commit }, dto: IAddMultiToBasketRequest) {
    try {
      localStorage.setItem('isFirstAddToCart', 'false')

      await apolloClient.mutate<IAddToBasketResponse, IAddMultiToBasketRequest>({
        mutation: fetchMultiProductsToCartMutation,
        variables: dto
      })
    } catch (error: any) {
      console.error('Add multiple to cart error:', error)
      throw new Error(error.message)
    } finally {
      commit(BasketMutationTypes.SET_LOADING, false)
    }
  },
  async [BasketActionTypes.FETCH_ORDER_REASON] ({ commit }, dto: any) {
    try {
      const data = await fetchOrderReason({
        soldToId: dto.soldToId,
        deliveryDate: dto.deliveryDate
      })
      if (data) {
        commit(BasketMutationTypes.ORDER_REASON, data)
      }
    } catch (e: unknown) {
      commit(BasketMutationTypes.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [BasketActionTypes.FETCH_PAYMENT_METHOD] ({ commit }, dto: any) {
    try {
      const data = await fetchPaymentMethod({
        payerid: dto.payerid,
        lang: dto.lang
      })
      if (data?.payers?.length > 0) {
        commit(BasketMutationTypes.PAYMENT_METHOD_CODE, data.payers[0].paymentmethod)
        if (dto.lang === 'en') {
          commit(BasketMutationTypes.PAYMENT_METHOD, data.payers[0].paymentmethodDescriptionEN)
        } else {
          commit(BasketMutationTypes.PAYMENT_METHOD, data.payers[0].paymentmethodDescription)
        }
      }
    } catch (e: unknown) {
      commit(BasketMutationTypes.SET_ERROR, e as IError[])
      throw e
    }
  },
  async [BasketActionTypes.FETCH_ORDER_TYPE] ({ commit }, dto: any) {
    try {
      const data = await fetchOrderType({
        soldToId: dto.soldToId
      })
      if (data) {
        commit(BasketMutationTypes.ORDER_TYPE, data)
      }
    } catch (e: unknown) {
      commit(BasketMutationTypes.SET_ERROR, e as IError[])
      throw e
    }
  }
}
const fetchPaymentMethod = async (dto: {payerid: string, lang: string}): Promise<any> => {
  const response: AxiosResponse = await generalServiceV1API.get<any>(`payers/${dto.payerid}`)
  return response.data
}

const BasketModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

function parseCartQuery (cart: BaseCartQueryResponse | any) {
  cart?.items?.map((item: BaseCartQueryItem) => {
    item.prices.price_details = JSON.parse(item.prices.price_details as unknown as string)
    item.prices.multi_deposit_details = JSON.parse(item.prices.multi_deposit_details as unknown as string)
    if (item.product?.bundle_price_details != null) {
      item.product.bundle_price_details = JSON.parse(item.product.bundle_price_details as string)
    }
    return item
  })
  cart.grand_total_your_price_details = JSON.parse(cart.grand_total_your_price_details as string)
  return cart
}

function mappingPriceValues (data:ICartQueryResponse):ICartQueryResponse {
  return {
    ...data,
    cart: {
      ...data.cart,
      items: data.cart.items.map(item => {
        return {
          ...item,
          prices: {
            ...item.prices,
            ...item.prices.your_price_details
          }
        }
      })
    }
  }
}

export default BasketModule
